export default "__VITE_ASSET__CnqiVY6$__"